import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CloseIcon from "@mui/icons-material/Close";

const SubjectSubmitModal = ({
  open,
  onClose,
  onConfirm,
  subjectName = "this subject",
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      {/* Title */}
      <DialogTitle sx={{ pr: 5 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <WarningAmberIcon color="warning" />
          <Typography variant="h6">Confirm Submission</Typography>
        </Box>

        {/* Close Icon */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "grey.500",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* Content */}
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to submit{" "}
          <strong>{subjectName}</strong>?
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 1 }}
        >
          Once submitted, you will not be able to change your answers.
        </Typography>
      </DialogContent>

      {/* Actions */}
      <DialogActions>
       
        <Button
          variant="contained"
          color="primary"
          onClick={onConfirm}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubjectSubmitModal;
